let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jE3Cj")).then(() => parcelRequire('g2ZRp'));